$(document).ready(function() {

    // BARRIEREFREIHEIT
    var openText = $("#naviHolder").data("open");
    var closeText = $("#naviHolder").data("close");
    var mainNav = document.getElementById('mainNavigation')

    // Hauptnavigation nicht klickbar (Akkordion-Funktion) - Trigger Klick auf Plus-Minus-Button
    $('.subLevelLink').on('click', function(e) {
        $(this).next().trigger('click');
    });

    // Submenu öffnen bei Click auf Pfeil-Button
    $("#naviHolder .menu-toggle").click(function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('hovered');
        $(this).parent().toggleClass('open');
        $(this).attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
        $(this).find('span.sr-only').toggleText($(this).parent().find('> a').text() + " - " + openText, $(this).parent().find('> a').text() + " - " + closeText);

        ($('#mainNavigation').prop('scrollHeight') > $('#mainNavigation').prop('clientHeight')) ? $('#mainNavigation').addClass("scrollbar-on") : $('#mainNavigation').removeClass("scrollbar-on");
    });

    // Submenu öffnen bei Click auf Pfeil-Button
    $("nav.langNavigation .lang-menu-toggle").click(function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('hovered');
        $(this).attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
        $(this).find('span.sr-only').toggleText($("nav.langNavigation").attr('aria-label') + " - " + openText, $("nav.langNavigation").attr('aria-label') + " - " + closeText);
    });

    $("nav.langNavigation ul").on('mouseover', function(e) {
        $(this).parent().addClass('hovered');
        $("nav.langNavigation .lang-menu-toggle").attr('aria-expanded', 'true');
        $("nav.langNavigation .lang-menu-toggle").find('span.sr-only').text($("nav.langNavigation").attr('aria-label') + " - " + closeText);
    });

    $("nav.langNavigation ul").on('mouseleave', function(e) {
        $(this).parent().removeClass('hovered');
        $("nav.langNavigation .lang-menu-toggle").attr('aria-expanded', 'false');
        $("nav.langNavigation .lang-menu-toggle").find('span.sr-only').text($("nav.langNavigation").attr('aria-label') + " - " + openText);
    });

    // show Chatbot Button if Marketing Cookies accepted
    if ($.cookie('cookieConsented-marketing') == "1" && $('#mobileBottomTrigger ul').find('li.chatbot').length) {
        $('#mobileBottomTrigger').addClass('chatbotBtn_1').removeClass('chatbotBtn_0');
    } else {
        $('#mobileBottomTrigger').addClass('chatbotBtn_0').removeClass('chatbotBtn_1');
    }

    if ($('#mobileBottomTrigger li.ulm').length) {
        $('#mobileBottomTrigger').addClass('ulmBtn_1').removeClass('ulmBtn_0');
    } else {
        $('#mobileBottomTrigger').addClass('ulmBtn_0').removeClass('ulmBtn_1');
    }

    // Menü verstecken sobald mobil wird > sosnt kann man bei pageLoad noch reintabben
    $(window).resize(function() {
        if ($(window).width() < 992 && $('#naviHolder').hasClass('showNavi') && !$('#naviHolder #quickIconsMobile').hasClass('showSearch')) {
            $('#mobileBottomTrigger li.menu a').click();
        }
    });


    // Desktop Menü Trigger
    $('#main-menu-open button').click(function(e) {
        e.preventDefault();
        $('#naviHolder').addClass('desktop-show');
        $('#naviHolder').addClass('showNavi');
        $('body').addClass('stop-scrolling');
        $('#naviHolder').attr('role', 'dialog').attr('aria-modal', 'true');
        openDialog("naviHolder", $(this));
        $("#naviHolder").show();
        $('body').addClass('stop-scrolling');
    });

    $('#main-menu-close button.trigger').click(function(e) {
        e.preventDefault();
        $('#naviHolder').removeClass('desktop-show');
        $('#naviHolder').removeClass('showNavi');
        $('body').removeClass('stop-scrolling');
        $('#naviHolder').removeAttr('role', 'dialog').removeAttr('aria-modal', 'true');
        topDialog = aria.getCurrentDialog();
        topDialog.close();
        $("#naviHolder").hide();
        $('body').removeClass('stop-scrolling');
    });

    // MOBILE BOTTOMTRIGGER
    $('#mobileBottomTrigger a').click(function(e) {

        var $ul = $(this).closest('ul');
        var mode = $(this).data('mode');
        if (mode !== 'ulm' && mode !== 'suche') {
            e.preventDefault();

            var showMode = false;
            var topDialog;

            switch (mode) {
                case "menu":
                    if ($ul.hasClass('d-flex')) {
                        if ($ul.hasClass('booking')) {
                            $ul.removeClass('booking').addClass(mode);
                            $('body').removeClass('blackout');
                            showMode = 'show_' + mode;
                        } else {
                            $ul.removeClass();
                        }
                    } else {
                        $ul.addClass('d-flex ' + mode);
                        showMode = 'show_' + mode;
                    }
                    $('#ajaxBuchenFilter').removeClass('showBooking');

                    if (showMode === 'show_menu') {
                        $('body').addClass('stop-scrolling');
                        $('#naviHolder').addClass('showNavi');
                        $('#naviHolder').attr('role', 'dialog').attr('aria-modal', 'true');
                        openDialog("naviHolder", $(this));
                        $("#naviHolder").show();
                    } else {
                        $('#naviHolder').removeClass('showNavi');
                        $('#naviHolder').removeAttr('role', 'dialog').removeAttr('aria-modal', 'true');
                        topDialog = aria.getCurrentDialog();
                        topDialog.close();
                        $("#naviHolder").hide();
                        $('body').removeClass('stop-scrolling');
                    }

                    var open = $(this).find('span.sr-only').data('open');
                    var close = $(this).find('span.sr-only').data('close');

                    $(this).find('span.sr-only').toggleText(open, close);
                    break;

                case "booking":
                    if ($('#td .buchenFilter.v2').length) {
                        // wenn auf TD Liste mit Buchenbox scrolle dort hin, lade nicht die AJAX Box und blende Menü aus
                        document.getElementById("td").scrollIntoView();
                        $ul.removeClass();
                        $('body').removeClass('blackout');
                        // } else if ($('#ttgQuickNaviBuchenBox').length) {
                        //     // wenn Custom Booking (Tomas, Feratel, Tiscover) scrolle zur Quicknavi, blende Buchungsleiste ein & blende Menü aus
                        //     document.getElementById("bookingStrip").scrollIntoView();
                        //     $('#ttgQuickNaviBuchenBox').show();
                        //     $ul.removeClass();
                        //     $('body').removeClass('blackout');
                    } else if ($('#bookingStrip.jump2Uid').length) {
                        $('body').addClass('blackout');
                        window.location.href = $('#bookingStrip.jump2Uid a').prop('href');
                    } else {
                        $('body').addClass('blackout');
                        if ($ul.hasClass('d-flex')) {
                            if ($ul.hasClass('menu')) {
                                $ul.removeClass('menu').addClass(mode);
                                $('#naviHolder').removeClass('showNavi');
                                $('#naviHolder').removeAttr('role', 'dialog').removeAttr('aria-modal', 'true');
                                topDialog = aria.getCurrentDialog();
                                topDialog.close();
                                $("#naviHolder").hide();
                                $('body').removeClass('stop-scrolling');
                            } else {
                                $ul.removeClass();
                                $('body').removeClass('blackout');
                            }
                        } else {
                            $ul.addClass('d-flex ' + mode);
                        }
                        // ajaxBuchenFilter('ajaxBuchenFilterMobile'); // nicht mehr nötig
                        ajaxBuchenFilter('ajaxBuchenFilter');
                    }
                    break;

                case "chatbot":
                    $("#onlim-chat-widget-trigger").contents().find(".cw-f-trigger").trigger("click");
                    break;
            }
        }
    });

    // Menü mit ESC schließen
    $('body').on('keydown', '#naviHolder', function(e) {
        var code = e.which;
        // 27 = ESC
        if ((code === 27)) {
            if ($('#mobileBottomTrigger ul').hasClass('d-flex')) {
                $('#mobileBottomTrigger ul li.menu a').click();
            } else if ($('#naviHolder .subLevel').hasClass('hovered')) {
                $('#naviHolder .subLevel.hovered .menu-toggle').click();
            } else if ($('#naviHolder').hasClass('desktop-show')) {
                $('#naviHolder #main-menu-close button.trigger').click();
            }
        }
    });

    if ($('#bookingStrip.jump2Uid').length) {
        $('#mobileBottomTrigger').addClass('jump2Uid_1');
    }

    // Sprachwähler nur einfügen wenn es mehrere Sprachen gibt
    // if ($('nav.langNavigation ul li').length > 1) {
    //     var translatedAndActivated = 0;
    //     $('nav.langNavigation ul li').each(function(i, item) {
    //         // ohne die aktuelle Sprache
    //         if (!$(item).hasClass('current')) {
    //             // jene übersetzen Seiten, welche aber nicht aktiviert sind
    //             if ($(item).attr('style') != 'display:none;') {
    //                 translatedAndActivated++;
    //             }
    //         }

    //         $(item).find('a').click(function(e) {
    //             if (is_touch_device4()) {
    //                 if (!$(this).closest('ul').hasClass('hover')) {
    //                     e.preventDefault();
    //                     $(this).closest('ul').addClass('hover');
    //                 } else {
    //                     if ($(this).closest('li').hasClass('current')) {
    //                         e.preventDefault();
    //                         $(this).closest('ul').removeClass('hover');
    //                     }
    //                 }
    //             }
    //         });

    //     });
    //     if (translatedAndActivated > 0) {
    //         $('nav.langNavigation').addClass('d-flex');
    //     }

    //     // LANG SWITCH POS [deaktiviert > nach Abstimmung mit RKA am 20.11. fix positioniert >> FKR]
    //     // var headerLogoW = $('#headerLogo').width();
    //     // var navW = 0;
    //     // $.each($('#mainNavigation .l1>li'), function(e) {
    //     //     navW = navW + $(this).width() + 25; // 25px sind der Margin
    //     // });
    //     // var langPosW = headerLogoW + navW + 15; // 15px weil sieht besser aus
    //     // $('#langNavigation').css('left', langPosW + 'px');
    // }

    // Quick Navi Search Mobile
    // if ($('#ttgQuickNaviSearch form#ttgSearchForm').length) {
    //     var action = $('#ttgQuickNaviSearch form#ttgSearchForm').prop('action');
    //     var $naviHolder = $('#newWAheader .naviHolder');
    //     var $searchForm = $('<form />').prop('id', 'headerSearchForm').prop('action', action);
    //     $searchForm.append($('<input />').prop('type', 'text'), $('<button />').append($('<span />').addClass('fas fa-search')));
    //     $searchForm.submit(function(e) {
    //         e.preventDefault();
    //         window.location.href = action + '#q=text:"' + $searchForm.find('input[type="text"]').val() + '"';
    //     });
    //     $naviHolder.append($searchForm);
    // }

});

function is_touch_device4() {

    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

    var mq = function(query) {
        return window.matchMedia(query).matches;
    };

    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}
//
// console.log(is_touch_device4());

(function($) {
    $.fn.toggleText = function(a, b) {
        return this.text(this.text() == b ? a : b);
    };
}(jQuery));
